import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { RoutingPathsTree } from '@core/constants/routing-paths-tree.const';
import { PermissionsEnum } from '@core/enums/permissions.enum';
import { PermissionsService } from '@core/services/permissions.service';
import { Observable } from 'rxjs';

@Injectable()
export class PermissionGuard implements CanActivate {
    constructor(
        private permissionsService: PermissionsService,
        private router: Router
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | boolean
        | UrlTree
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree> {
        const permissions: PermissionsEnum | PermissionsEnum[] =
                route.data['permissions'],
            result: boolean =
                this.permissionsService.isAllowedByAllPermissions(permissions);
        if (!result) {
            this.router.navigate([RoutingPathsTree.NotFounded.route]);
        }
        return result;
    }
}
